import * as React from 'react'
import styled from 'styled-components'
import { getBreakpoint } from '../../styles/getBreakpoint'
import { calcFontScale } from '../../styles/calcFontScale'
import { SPACE } from '../../styles/constants'
import { Container } from '../Container'
import { ChannelList } from '../ChannelList'
import { injectIntl, InjectedIntlProps, defineMessages } from 'react-intl'
import { Select } from '../Select'
import { Link } from '../Link'
import { lighten } from 'polished'
// @ts-ignore
import * as theme from 'styled-theming'

const messages = defineMessages({
  termsOfUse: {
    id: 'footer.terms_of_use',
    defaultMessage: 'Terms of Use',
  },
  privacyPolicy: {
    id: 'footer.privacy_policy',
    defaultMessage: 'Privacy Policy',
  },
  selectYourLanguage: {
    id: 'footer.select_your_language',
    defaultMessage: 'Select Your Language',
  },
})

interface Props {}

const FooterWrapped: React.SFC<Props & InjectedIntlProps> = ({ intl }) => (
  <Wrapper>
    <Inner>
      <Item>
        <Select
          title={intl.formatMessage(messages.selectYourLanguage)}
          name="lang"
          value="en"
          options={[
            { value: 'en', label: 'English' },
            { value: 'ja', label: '日本語' },
            { value: 'ko', label: '한국어' },
          ]}
          onChange={() => {}}
        />
      </Item>
      <Item>
        <span>
          Steadio by Tumblbug Inc. © 2018{' '}
          <Link to="https://tumblbug.com/terms-of-use">
            {intl.formatMessage(messages.termsOfUse)}
          </Link>{' '}
          ·{' '}
          <Link to="https://tumblbug.com/privacy">
            {intl.formatMessage(messages.privacyPolicy)}
          </Link>
        </span>
        <ChannelList />
      </Item>
    </Inner>
  </Wrapper>
)

const colors = {
  divider: theme('mode', {
    light: (props: any) => lighten(0.875, props.theme.color.black),
    dark: (props: any) => lighten(0.125, props.theme.color.black),
  }),
}

const Wrapper = styled.footer`
  border-top: 1px solid ${colors.divider};
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  ${calcFontScale(-1)};
`
const Inner = styled(Container)`
  ${SPACE.inset.xs};
  ${getBreakpoint(0)`
		align-items: center;
		display: flex;
		justify-content: space-between;
	`};
`

const Item = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  ${SPACE.inset.xs};
`

export default injectIntl(FooterWrapped)



// WEBPACK FOOTER //
// ./src/components/Footer/index.tsx